import { QueryHookOptions } from '@apollo/client';
import { useQuery } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

// const SecurityRoleEnum = createTypedEnum({
//   Approver: 'Approver',
//   WorkflowAdministrator: 'WorkflowAdministrator',
//   Reviewer: 'Reviewer',
//   Staff: 'Staff',
// } as const);

// export const SecurityRole = SecurityRoleEnum.valuesEnum;

// export type SecurityRoleType = typeof SecurityRoleEnum.values[number];

export const GET_TEMPLATE_QUERY = gql`
  query GetTemplate($cloudId: String!) {
    getTemplate(cloudId: $cloudId) {
      cloudId
      name
      description
      wfCreatedBy
      wfCreatedOnUTC
      wfDeletedOnUTC
      templateTasks {
        cloudId
        entityTypeId
        name
        ownerUserId
        jobUserType
        taskTypeId
        estimateMinutes
        wfCreatedBy
        wfCreatedOnUTC
        wfDeletedBy
        wfDeletedOnUTC
      }
      entities
    }
  }
` as import('../../__generated__/ts-gql/GetTemplate').type;

export type GetTemplateQueryVariables = OperationVariables<
  typeof GET_TEMPLATE_QUERY
>;
export type GetTemplateQueryResult = OperationData<typeof GET_TEMPLATE_QUERY>;
export type GetTemplateResult = NonNullable<
  GetTemplateQueryResult['getTemplate']
>;
export type GetTemplateResultTemplateTask = NonNullable<
  GetTemplateResult['templateTasks']
>[number];

export type Template = NonNullable<ReturnType<typeof processData>>;
export type TemplateTasks = NonNullable<Template['templateTasks']>;
export type TemplateEntities = NonNullable<Template['entities']>;

export const useGetTemplate = (
  options: QueryHookOptions<GetTemplateQueryResult, GetTemplateQueryVariables>
) => {
  const variables = options.variables as GetTemplateQueryVariables;

  const res = useQuery(GET_TEMPLATE_QUERY, {
    context: { service: 'templates' },
    variables,
    ...options,
  });

  return React.useMemo(() => ({ ...res, data: processData(res.data) }), [res]);
};

export function processData(data: GetTemplateQueryResult | undefined) {
  const sourceTemplate = data?.getTemplate;
  if (!sourceTemplate) {
    return;
  }
  const templateTasks = (sourceTemplate.templateTasks || []).map((tt) => {
    return {
      cloudId: tt.cloudId || '',
      name: tt.name || '',
      taskTypeId: tt.taskTypeId!,
      templateId: sourceTemplate!.cloudId,
      entityTypeId: tt.entityTypeId,
      estimateMinutes: tt.estimateMinutes,
      jobUserType: tt.jobUserType,
      ownerUserId: tt.ownerUserId,
      wfCreatedBy: sourceTemplate.wfCreatedBy,
      wfCreatedOnUTC: sourceTemplate.wfCreatedOnUTC,
      wfDeletedOnUTC: sourceTemplate.wfDeletedOnUTC,
    };
  });

  const template = {
    cloudId: sourceTemplate.cloudId || '',
    description: sourceTemplate.description || '',
    name: sourceTemplate.name || '',
    entities: [...(sourceTemplate.entities || [])],
    templateTasks,
    wfCreatedBy: sourceTemplate.wfCreatedBy,
    wfCreatedOnUTC: sourceTemplate.wfCreatedOnUTC,
    wfDeletedOnUTC: sourceTemplate.wfDeletedOnUTC,
  };

  return template;
}
